import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const FieldLabel = ({ field, text, customClassName, variant = "h4", component = "span" }) => {
  const className = customClassName || `${field}Label`;

  return (
    <Typography className={className} variant={variant} component={component} data-testid={`${field}Label`}>
      {text}
    </Typography>
  );
};

FieldLabel.propTypes = {
  field: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  customClassName: PropTypes.string,
  variant: PropTypes.string,
  component: PropTypes.string,
};

export default FieldLabel;
